export default __webpack_public_path__ + "static/media/GothamSSm-Book.3a7a4ce9.woff";